// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2ZSxS","bigColWidth":"Table_bigColWidth__3WE4s","biggerColWidth":"Table_biggerColWidth__1Y8rs","row":"Table_row__2Aodh","col":"Table_col__18A4X"};